module.exports = "<mat-chip-list #chipList aria-label=\"keyword selection\">\r\n  <mat-chip *ngFor=\"let word of searchKeyWordList;let i = index\" [selectable]=\"selectable\"\r\n      [removable]=\"removeChip\" (removed)=\"remove(word)\" class=\"mb-4\">\r\n      {{word|uppercase}}\r\n      <mat-icon matChipRemove *ngIf=\"removeChip\">cancel</mat-icon>\r\n  </mat-chip>\r\n</mat-chip-list>\r\n"


//////////////////
// WEBPACK FOOTER
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/main/content/apps/common/mat-chip-list/mat-chip-list.component.html
// module id = ../../../../../src/app/main/content/apps/common/mat-chip-list/mat-chip-list.component.html
// module chunks = main